import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import moment from "moment";

class NotificationTable extends React.Component {
    render () {
        const { notification, title } = this.props;

        return (
            <div className="card">
                <div className="card-header p-1 pl-2 pr-2">
                    <h4 className="mb-0">{title} ({notification && `Services: ${notification.length}`})</h4>
                </div>
                <div className="card-body p-0">
                    <ReactTable
                        data={notification}
                        headerClassName="table-header"
                        columns={[
                        {
                            Header: "Job Number",
                            headerClassName: "text-left",
                            accessor: "jobNumber",
                        }, 
                        {
                            Header: "Store Number",
                            headerClassName: "text-left",
                            accessor: "storeNumber",
                        },
                        {
                            id: "dueDate",
                            Header: "Due Date",
                            headerClassName: "text-left",
                            accessor: "dueDate",
                            Cell: ({ original }) => (
                                <div className="text-left">
                                    {moment(original.dueDate).format("YYYY-MM-DD")}
                                </div>
                            ),
                        }]}
                        showPagination={false}
                        className="-striped -highlight schedules-table"
                        style={{
                            height: 200,
                        }}
                    />
                </div>
            </div>
        );
    }
}

NotificationTable.propTypes = {
    notification: PropTypes.array
};

export default NotificationTable;
